/* Manifest List, Vue Component */
<template>
  <v-card id="manifest-list">
    <v-card-title>Manifests</v-card-title>

    <v-card-text class="d-flex align-center flex-wrap pb-0">
      <div class="d-flex" style="width:100%; justify-content: space-between;">

        <v-btn color="primary" class="me-3" :to="{ name: 'manifest-create' }">
          <v-icon size="18" class="me-1">
            {{ icons.mdiPlus }}
          </v-icon>
          <span>Create Manifest</span>
        </v-btn>



      </div>
    </v-card-text>

    <v-card-text class="d-flex align-center flex-wrap pb-0">

      <v-spacer></v-spacer>

      <div class="d-flex align-center pb-5">

        <CountrySelect class="mr-4" v-model="filter.CountryId" :outlined="true" :inverted="false" :hide-details="true"
          :dense="true" :filter="{ filter: { CanManifest: true } }" />
        <v-select v-model="filter.Closed" :items="filterItems.Closed" single-line outlined dense hide-details clearable
          placeholder="Filter Status" class="mr-4"></v-select>

      </div>
    </v-card-text>

    <!-- table -->
    <v-data-table v-model="selectedItems" :headers="tableColumns" :items="items" :options.sync="options"
      :server-items-length="totalItems" :loading="loading" :footer-props="footerProps" class="text-no-wrap">

      <template #[`item.CountryId_Name`]="{ item }">
        <router-link class="font-weight-medium text-decoration-none"
          :to="{ name: 'manifest-view', params: { id: item.Id } }" v-if="item.Closed">
          {{ item.CountryId_Name }}
        </router-link>
        <router-link class="font-weight-medium text-decoration-none"
          :to="{ name: 'manifest-edit', params: { id: item.Id } }" v-if="!item.Closed">
          {{ item.CountryId_Name }}
        </router-link>
      </template>

      <template #[`item.ManifestDate`]="{ item }">
        {{ Display.DisplayDate(item.ManifestDate) }}
      </template>

      <template #[`item.Heavy`]="{ item }">
        {{ item.Heavy ? 'Heavy / Two Person' : 'Normal' }}
      </template>

      <template #[`item.Closed`]="{ item }">
        <v-chip color="error" text-color="white" small v-if="item.Closed">Closed</v-chip>
        <v-chip color="primary" text-color="white" small v-if="!item.Closed">Open</v-chip>
      </template>

      <!-- actions -->
      <template #[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-center">
          <ActionsDropdown :item="item" :actionOptions="actionOptions" />
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import store from '@/store'

import { mdiPlus } from '@mdi/js'

import { ref, watch, computed } from '@vue/composition-api'
import * as Validators from '@/datahelpers/validation'
import * as Display from '@/datahelpers/displayTypes'
import CountrySelect from '@/views/country/CountrySelect'

export default {
  components: {
    CountrySelect,
  },
  setup() {
    // define cols
    const tableColumns = [
      { text: 'Country', value: 'CountryId_Name' },
      { text: 'Date', value: 'ManifestDate' },
      { text: 'Index', value: 'ManifestIndex' },
      { text: 'Size', value: 'Heavy' },
      { text: 'Status', value: 'Closed' },
    ]

    // threee params for fetching
    const search = ref({})
    const filter = ref({})
    const options = ref({
      sortBy: ['ManifestDate'],
      sortDesc: [true],
      itemsPerPage: 20,
    })
    const footerProps = {
      'items-per-page-options': [10, 20, 50, 100, -1],
    }

    // items
    const items = computed(() => store.state.app.Manifests || [])
    const totalItems = computed(() => store.state.app.ManifestsTotal || 0)
    const selectedItems = ref([])
    const loading = ref(false)

    // data for filter fields
    const filterItems = ref({
      Closed: [
        { text: 'Open', value: false },
        { text: 'Closed', value: true },
      ],
    })

    // Island and Size dropdowns for Manifest
    const islandItems = [
      { text: 'Jersey', value: 'jersey' },
      { text: 'Guernsey', value: 'guernsey' },
    ]
    const sizeItems = [
      { text: 'Both', value: 'both' },
      { text: 'Small', value: 'small' },
      { text: 'Two Person', value: 'twoperson' },
    ]
    const manifestIsland = ref('jersey')
    const manifestSize = ref('both')
    const confirmDialog = ref(false)

    const showConfirmDialog = () => {
      confirmDialog.value = true
    }

    const confirmManifestAndDispatch = () => {
      confirmDialog.value = false
      manifestAndDispatch()
    }

    const manifestAndDispatch = () => {
      loading.value = true
      store
        .dispatch('app/manifestAndDispatch', {
          island: manifestIsland.value,
          size: manifestSize.value,
        })
        .then(response => {
          loading.value = false
          setTimeout(() => {
          fetchData()
          }, 10)

        })
        .catch(error => {
          console.log(error)
        })
    }

    // method for data loading via vuex
    const fetchData = () => {
      store
        .dispatch('app/fetchManifests', {
          search: search.value,
          options: options.value,
          filter: filter.value,
        })
        .then(response => {
          loading.value = false
        })
        .catch(error => {
          console.log(error)
        })
    }

    watch(
      [search, filter, options],
      () => {
        loading.value = true
        fetchData()
      },
      { deep: true },
    )

    return {
      tableColumns,
      search,
      filterItems,
      filter,
      options,
      totalItems,
      manifestAndDispatch,
      items,
      loading,
      selectedItems,
      footerProps,
      islandItems,
      sizeItems,
      manifestIsland,
      manifestSize,
      confirmDialog,
      showConfirmDialog,
      confirmManifestAndDispatch,
      Validators,
      Display,
      icons: {
        mdiPlus,
      },
    }
  },
}
</script>

<style lang="scss" scoped></style>
